import api from './api';

export interface CreatePatientLinkPayload {
  patient_id: string;
  clinic_id: string;
  purpose: string;
  related_entity_type?: string;
  related_entity_id?: string;
  metadata?: Record<string, unknown>;
  max_uses?: number;
  expires_in_days?: number;
  otp_required?: boolean;
  send_channel?: 'email' | 'sms' | 'both';
  send_to_contact?: boolean;
}

export interface PatientLink {
  id: string;
  patient_id: string;
  clinic_id: string;
  purpose: string;
  status: string;
  expires_at: string;
  created_at: string;
  use_count: number;
  max_uses: number | null;
  sessions?: Array<{
    id: string;
    created_at: string;
    expires_at: string;
    is_active: boolean;
    last_active_at?: string;
  }>;
}

export interface PatientLinksResponse {
  links: PatientLink[];
  pagination: {
    page: number;
    limit: number;
    totalItems: number;
    totalPages: number;
  };
}

export const patientLinkService = {
  /**
   * Create a new patient action link
   */
  createPatientLink: async (payload: CreatePatientLinkPayload) => {
    const response = await api.post(`/clinic/${payload.clinic_id}/patient-links`, payload);
    return response.data;
  },

  /**
   * Get patient links for a patient
   */
  getPatientLinks: async (
    clinicId: string,
    patientId: string,
    options?: Record<string, unknown>
  ) => {
    const params = new URLSearchParams();
    params.append('patient_id', patientId);
    if (options?.status) params.append('status', options.status as string);

    const response = await api.get(
      `/clinic/${clinicId}/patient-links?${params.toString()}`,
      options
    );
    return response.data;
  },

  /**
   * Revoke a patient link
   */
  revokePatientLink: async (clinicId: string, linkId: string) => {
    const response = await api.post(`/clinic/${clinicId}/patient-links/${linkId}/revoke`);
    return response.data;
  },
};

export default patientLinkService;
